import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-admin-route-management',
  imports: [RouterModule],
  templateUrl: './admin-route-management.html',
  styleUrl: './admin-route-management.scss',
})
export class AdminRouteManagement {}
